import { render } from "./AlzataAppHeader.vue?vue&type=template&id=2b9245de"
import script from "./AlzataAppHeader.vue?vue&type=script&lang=js"
export * from "./AlzataAppHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__